<template>
  <section class="c-accesslink-form text-center">
    <div class="container">
      <div class="block p-t-b content-narrow">
        <h2 class="fnt font-default-light">
          {{ $t("ACCESS_LINK_FORM__INTRO1") }}
        </h2>
        <stamp></stamp>
        <h3 class="fnt font-default-light" style="margin-top: 0">
          {{ $t("ACCESS_LINK_FORM__TITLE") }}
        </h3>
        <p class="fnt font-default">
          {{ $t("ACCESS_LINK_FORM__INTRO2") }}
        </p>
        <el-form
          :model="form"
          :rules="rules"
          :validateOnRuleChange="false"
          @submit.prevent.native
          ref="form"
        >
          <el-collapse-transition>
            <div class="block p-b" v-if="success || apiErrors.length > 0">
              <el-alert
                v-if="success"
                :title="$t('ACCESS_LINK_FORM__ON_SUCCESS')"
                type="success"
                effect="dark"
                key="alert-error"
              >
              </el-alert>
              <el-alert
                v-if="apiErrors.length > 0"
                :title="apiErrors[0]"
                type="error"
                effect="dark"
                key="alert-success"
              >
              </el-alert>
            </div>
          </el-collapse-transition>

          <el-form-item prop="email" class="block p-b with-control-label">
            <el-input
              v-model="form.email"
              @keyup.enter.native="submit"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
              id="email"
            >
              <label
                for="email"
                slot="prepend"
                :class="[isLabelActive('email') ? 'active' : '']"
                >{{ $t("SHARED__EMAIL_PLACEHOLDER") }}</label
              >
              <el-button
                slot="append"
                type="primary"
                @click="submit"
                class="no-anim"
              >
                <i
                  :class="[
                    loading ? 'fas fa-spinner fa-spin' : 'far fa-envelope'
                  ]"
                ></i>
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
import to from "await-to-js"

import Stamp from "../Lib/Stamp"
import AccessLinkService from "../../services/api/AccessLinkService"

const accessLinkService = new AccessLinkService()

export default {
  name: "AccessLinkForm",
  components: {
    Stamp
  },
  data() {
    return {
      loading: false,
      inFocus: null,
      form: {
        email: null
      },
      success: null,
      apiErrors: []
    }
  },
  computed: {
    rules() {
      return {
        email: [
          {
            required: true,
            pattern: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            message: this.$t("SHARED__EMAIL_VALIDATION"),
            trigger: "blur"
          }
        ]
      }
    }
  },
  methods: {
    async getAccessLink() {
      this.loading = true
      let err
      ;[err] = await to(
        accessLinkService.sendAccessLinkRequest(this.form.email)
      )

      this.loading = false

      if (err) {
        switch (err.response.status) {
          case 404:
            this.apiErrors.push(this.$t("ACCESS_LINK_FORM__NO_USER"))
            break
          case 429:
            this.apiErrors.push(this.$t("ACCESS_LINK_FORM__EMAIL_ALREADY_SENT"))
            break
          default:
            this.apiErrors.push(this.$t("ACCESS_LINK_FORM__ON_ERROR"))
        }
      } else {
        this.success = true
      }
    },
    submit() {
      this.apiErrors = []
      this.success = null
      this.$refs.form.validate(valid => {
        if (valid) {
          this.getAccessLink()
        } else {
          return false
        }
      })
    },
    isLabelActive(field) {
      return this.inFocus === field || this.form[field]
    },
    handleInputFocus(evt) {
      this.inFocus = evt.target.id
    },
    handleInputBlur(evt) {
      const id = evt.target.id
      if (this.inFocus === id) {
        this.inFocus = null
      }
    }
  }
}
</script>

<style scoped></style>
